{
  "header": {
    "title": "Helpdesk",
    "description": "Laadpaalstoringen en de afhandeling daarvan."
  },
  "noAccess": {
    "title": "Toegang niet beschikbaar",
    "description": "Je toegangsniveau kon niet worden bepaald. Probeer het later opnieuw."
  },
  "unavailable": {
    "title": "Helpdesk is niet beschikbaar",
    "description": "De helpdeskmodule is niet beschikbaar in deze omgeving."
  },
  "filters": {
    "aria": "Storingen filteren",
    "status": "Status",
    "open": "Openstaand",
    "urgent": "Spoed",
    "notForwarded": "Niet doorgestuurd",
    "resolved": "Afgehandeld"
  },
  "table": {
    "title": "Storingen",
    "count": "{{count}} storing",
    "count_other": "{{count}} storingen",
    "searchPlaceholder": "Doorzoek storingen…",
    "searchAria": "Storingen zoeken",
    "columns": {
      "report": "Melding",
      "chargePoint": "Laadpaal",
      "fault": "Storing",
      "status": "Status"
    },
    "empty": {
      "title": "Geen storingen gevonden",
      "description": "Pas de filters aan of maak een nieuwe melding aan."
    },
    "error": {
      "title": "Storingen laden mislukt",
      "description": "Er ging iets mis bij het laden van de storingen. Probeer het opnieuw."
    }
  },
  "actions": {
    "newReport": "Nieuwe melding",
    "cancel": "Annuleren",
    "save": "Opslaan",
    "edit": "Bewerken",
    "delete": "Verwijderen",
    "forward": "Doorsturen",
    "forwardAgain": "Opnieuw doorsturen",
    "partnerResponse": "Reactie servicepartij",
    "markResolved": "Markeer als opgelost",
    "reopen": "Heropenen"
  },
  "status": {
    "open": "Openstaand",
    "resolved": "Afgehandeld"
  },
  "catalog": {
    "faultType": {
      "offline": "Laadpaal offline",
      "noPower": "Geen stroom",
      "cableStuck": "Laadkabel vast",
      "cardNotRecognized": "Pas niet herkend",
      "cableBlocked": "Kabel geblokkeerd",
      "faulted": "Status \"Faulted\" (rood lampje)",
      "noOutput": "Geen vermogen",
      "rfidFails": "RFID leest geen passen",
      "screenCracked": "Scherm gebarsten",
      "other": "Overig"
    },
    "socket": {
      "socket1": "Socket 1",
      "socket2": "Socket 2",
      "both": "Beide sockets",
      "all": "Alle sockets",
      "na": "nvt"
    },
    "snippet": {
      "noRemoteResponse": "Laadpaal reageert niet op afstand.",
      "resetPersists": "Op afstand gereset, storing blijft bestaan.",
      "customerNoPower": "Klant meldt: geen stroom, voertuig laadt niet.",
      "offlineBackoffice": "Laadpaal offline in de backoffice.",
      "rfidNotRecognized": "RFID-pas wordt niet herkend.",
      "cableStuckWaiting": "Laadkabel zit vast, EV-rijder staat te wachten.",
      "bothOutOfUse": "Beide sockets buiten gebruik.",
      "screenDefect": "Display of scherm defect."
    }
  },
  "badges": {
    "urgent": "Spoed",
    "forwarded": "Doorgestuurd",
    "notForwarded": "Niet doorgestuurd"
  },
  "form": {
    "addTitle": "Nieuwe storingsmelding",
    "editTitle": "Melding #{{number}} bewerken",
    "description": "Leg de laadpaal, de storing en eventuele details voor de servicepartij vast.",
    "sections": {
      "chargePoint": "Laadpaal & storing",
      "notes": "Opmerkingen",
      "reporter": "Gegevens melder"
    },
    "reporterHint": "Gegevens van de melder (EV-rijder). Deze worden meegestuurd naar de servicepartij.",
    "connectorOption": "Connector {{n}}",
    "fields": {
      "chargePointId": "Laadstation-ID",
      "chargePointLabel": "Alias",
      "operator": "Operator / servicepartij",
      "faultType": "Storing",
      "socket": "Socket",
      "location": "Locatie",
      "urgent": "Spoed (laadkabel vast)",
      "notes": "Opmerkingen",
      "reporterName": "Naam melder",
      "reporterPhone": "Telefoonnummer",
      "reporterEmail": "E-mailadres"
    },
    "placeholders": {
      "chargePoint": "Zoek op station-ID, naam of locatie",
      "operator": "Kies een operator",
      "faultType": "Kies een storing",
      "socket": "Kies een socket",
      "notes": "Beschrijf de storing, wat al geprobeerd is en bijzonderheden op de locatie."
    },
    "errors": {
      "chargePointId": "Een laadpaal-ID is verplicht.",
      "operator": "Kies een operator.",
      "faultType": "Kies een storing.",
      "location": "Locatie is verplicht bij een spoedmelding.",
      "reporterName": "Naam melder is verplicht bij een spoedmelding.",
      "reporterPhone": "Telefoonnummer melder is verplicht bij een spoedmelding."
    }
  },
  "combo": {
    "loading": "Laadstations ophalen…",
    "noResults": "Geen laadstation gevonden. Pas de zoekopdracht aan — meldingen kunnen alleen voor stations uit de lijst worden aangemaakt."
  },
  "forward": {
    "title": "Melding #{{number}} doorsturen",
    "description": "Stuur deze melding per e-mail naar de servicepartij.",
    "fields": {
      "to": "Aan",
      "cc": "CC",
      "priorityHint": "Prioriteit-indicatie (optioneel)"
    },
    "placeholders": {
      "to": "ontvanger@servicepartij.nl, tweede@servicepartij.nl",
      "cc": "cc@voorbeeld.nl",
      "priorityHint": "bijv. hoog / normaal / laag"
    },
    "priorityHintNote": "Optioneel. De servicepartij bepaalt de definitieve prioriteit.",
    "confirm": "Melding versturen",
    "recipientsNote": "Scheid meerdere adressen met een komma."
  },
  "partner": {
    "title": "Reactie servicepartij · #{{number}}",
    "description": "Leg vast wat de servicepartij heeft teruggekoppeld.",
    "status": {
      "scheduled": "Monteur ingepland",
      "resolved": "Storing opgelost"
    },
    "fields": {
      "type": "Type reactie",
      "scheduledFor": "Ingepland op",
      "resolvedOn": "Opgelost op",
      "note": "Opmerking (optioneel)"
    },
    "placeholders": {
      "note": "Bijvoorbeeld: onderdeel besteld, monteur komt in de ochtend."
    },
    "clear": "Reactie wissen"
  },
  "detail": {
    "title": "Melding #{{number}}",
    "fields": {
      "number": "Storingsnummer",
      "date": "Datum",
      "chargePoint": "Laadpaal",
      "evse": "EVSE-ID",
      "operator": "Operator",
      "faultType": "Storing",
      "socket": "Socket",
      "location": "Locatie",
      "route": "Route"
    },
    "sections": {
      "reporter": "Melder",
      "notes": "Opmerkingen"
    },
    "forwardedTo": "Doorgestuurd naar {{email}} op {{date}}.",
    "notForwarded": "Nog niet doorgestuurd naar de servicepartij.",
    "partnerResolved": "Servicepartij heeft de storing als opgelost gemeld op {{date}}.",
    "partnerScheduled": "Servicepartij heeft een monteur ingepland op {{date}}."
  },
  "deleteDialog": {
    "title": "Melding verwijderen?",
    "description": "Melding #{{number}} wordt definitief verwijderd.",
    "confirm": "Ja, verwijderen"
  },
  "toasts": {
    "saved": "Melding #{{number}} opgeslagen.",
    "saveFailed": "Kon de melding niet opslaan.",
    "deleted": "Melding #{{number}} verwijderd.",
    "deleteFailed": "Kon de melding niet verwijderen.",
    "forwarded": "Melding #{{number}} verstuurd.",
    "forwardFailed": "Kon de melding niet doorsturen.",
    "partnerSaved": "Reactie servicepartij vastgelegd.",
    "partnerCleared": "Reactie servicepartij gewist.",
    "forwardedNotSent": "Melding #{{number}} vastgelegd als doorgestuurd, maar de e-mail is niet verzonden: {{detail}}",
    "resolved": "Melding #{{number}} gemarkeerd als opgelost.",
    "reopened": "Melding #{{number}} heropend.",
    "statusFailed": "Kon de status van de melding niet wijzigen."
  },
  "contacts": {
    "title": "Contactpersonen voor meldingen",
    "count": "{{count}} contactpersoon",
    "count_other": "{{count}} contactpersonen",
    "hint": "Deze personen krijgen een e-mail zodra er een storing wordt gemeld op een laadpaal in hun netwerk.",
    "wholeNetwork": "{{name}} (hele netwerk)",
    "columns": {
      "contact": "Contactpersoon",
      "target": "Geldt voor",
      "notify": "Meldingen"
    },
    "notify": {
      "on": "Aan",
      "off": "Uit"
    },
    "actions": {
      "add": "Contactpersoon toevoegen"
    },
    "empty": {
      "title": "Nog geen contactpersonen",
      "description": "Voeg een e-mailadres toe om op de hoogte te blijven van storingen in uw netwerk."
    },
    "error": {
      "title": "Contactpersonen konden niet worden geladen",
      "description": "Er ging iets mis bij het laden van de contactpersonen. Probeer het opnieuw."
    },
    "form": {
      "addTitle": "Nieuwe contactpersoon",
      "editTitle": "Contactpersoon bewerken",
      "description": "Wie moet er bericht krijgen bij een storing op een laadpaal in dit netwerk.",
      "targetHint": "Kies uw hele netwerk of één organisatie daarbinnen.",
      "emailHint": "Eén adres per contactpersoon. Voeg een tweede contactpersoon toe voor nog een adres.",
      "notifyHint": "Zet uit om de gegevens te bewaren zonder e-mails te versturen.",
      "fields": {
        "target": "Geldt voor",
        "name": "Naam",
        "email": "E-mailadres",
        "phone": "Telefoonnummer (optioneel)",
        "notify": "Mail mij bij nieuwe storingsmeldingen"
      },
      "placeholders": {
        "name": "Persoon of team, bijv. Facilitaire dienst",
        "email": "naam@bedrijf.nl",
        "phone": "+31 6 12345678"
      },
      "errors": {
        "name": "Een naam is verplicht.",
        "email": "Vul een geldig e-mailadres in."
      }
    },
    "deleteDialog": {
      "title": "Contactpersoon verwijderen?",
      "description": "{{name}} krijgt geen meldingen meer over storingen.",
      "confirm": "Ja, verwijderen"
    },
    "toasts": {
      "saved": "{{name}} opgeslagen.",
      "saveFailed": "Kon de contactpersoon niet opslaan.",
      "deleted": "{{name}} verwijderd.",
      "deleteFailed": "Kon de contactpersoon niet verwijderen."
    }
  }
}
